import React from 'react'
import {Navigate, Outlet} from 'react-router-dom';
import {useAuth} from "../contex/AuthContext.jsx";
import {Login_Route} from "../router/routes.js";

const PrivateRoute = ({children}) => {
    const {user, isLoading} = useAuth()
    if (isLoading) {
        return <div>Loading...</div>
    }

    if (!user) {
        return <Navigate to={Login_Route}/>
    }

    return children
}

export default PrivateRoute;